<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import OptionsMenu from './OptionsMenu.vue';
import AgentDetails from './AgentDetails.vue';
import NotificationBell from './NotificationBell.vue';
import wootConstants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';
import { useTrack } from 'dashboard/composables';
// Tutorial desativado temporariamente
// import { emitter } from 'shared/helpers/mitt';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    OptionsMenu,
    AgentDetails,
    NotificationBell,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  emits: ['toggleAccounts', 'openNotificationPanel', 'openKeyShortcutModal'],
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
      showOptionsMenu: false,
    };
  },
  methods: {
    frontendURL,
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggleAccounts');
    },
    toggleSupportChatWindow() {
      window.$chatwoot.toggle();
    },
    openNotificationPanel() {
      useTrack(ACCOUNT_EVENTS.OPENED_NOTIFICATIONS);
      this.$emit('openNotificationPanel');
    },
    //openTutorialModal() {
    //  emitter.emit('OPEN_TUTORIAL_MODAL');
    //},
  },
};
</script>

<template>
  <div
    class="flex flex-col w-16 h-full bg-white border-r dark:bg-slate-900 border-slate-50 dark:border-slate-800/50 rtl:border-l rtl:border-r-0">
    <!-- Header section with logo -->
    <div class="flex flex-col items-center flex-shrink-0 border-b border-slate-100 dark:border-slate-800 mb-3">
      <Logo :source="logoSource" :name="installationName" :account-id="accountId" class="m-4 mb-4" />
    </div>
    
    <!-- Scrollable navigation section -->
    <div class="flex flex-col items-center flex-1 overflow-y-auto scrollable-nav gap-2">
      <div v-for="menuItem in menuItems" :key="menuItem.toState" class="flex-shrink-0">
        <PrimaryNavItem :id="menuItem.key" :icon="menuItem.icon"
          :name="menuItem.label" :to="menuItem.toState" :is-child-menu-active="menuItem.key === activeMenuItem" />
      </div>
    </div>
    
    <!-- Fixed bottom section -->
    <div class="flex flex-col items-center justify-end pb-6 flex-shrink-0">
      <!-- <a
        v-if="!isACustomBrandedInstance"
        v-tooltip.right="$t(`SIDEBAR.DOCS`)"
        :href="helpDocsURL"
        class="relative flex items-center justify-center w-10 h-10 my-2 rounded-lg text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        <fluent-icon icon="book-open-globe" />
        <span class="sr-only">{{ $t(`SIDEBAR.DOCS`) }}</span>
      </a> -->
            <!-- <a
        v-tooltip.right="'Suporte'"
        href="https://wa.me/5518997298952"
        target="_blank"
        rel="noopener noreferrer"
        class="relative flex items-center justify-center w-10 h-10 my-2 rounded-lg text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600"
      >
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        <span class="sr-only">Suporte</span>
      </a> -->
      <!--
      <button
        v-tooltip.right="'Tutoriais'"
        class="relative flex items-center justify-center w-10 h-10 my-2 rounded-lg text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600"
        @click="openTutorialModal"
      >
        <fluent-icon icon="play-circle" />
        <span class="sr-only">Tutoriais</span>
      </button>
      -->
      <NotificationBell @open-notification-panel="openNotificationPanel" />
      <AgentDetails @toggle-menu="toggleOptions" />
      <OptionsMenu :show="showOptionsMenu" @toggle-accounts="toggleAccountModal"
        @show-support-chat-window="toggleSupportChatWindow" @open-key-shortcut-modal="$emit('openKeyShortcutModal')"
        @close="toggleOptions" />
    </div>
  </div>
</template>

<style scoped>
/* Custom scrollbar styles for navigation section */
.scrollable-nav {
  scrollbar-width: thin;
  scrollbar-color: rgb(203 213 225 / 0.5) transparent; /* slate-300 with opacity */
}

.scrollable-nav::-webkit-scrollbar {
  width: 4px;
}

.scrollable-nav::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable-nav::-webkit-scrollbar-thumb {
  background-color: rgb(203 213 225 / 0.5); /* slate-300 with opacity */
  border-radius: 2px;
}

.scrollable-nav::-webkit-scrollbar-thumb:hover {
  background-color: rgb(148 163 184 / 0.7); /* slate-400 with opacity */
}

/* Dark mode scrollbar */
.dark .scrollable-nav {
  scrollbar-color: rgb(71 85 105 / 0.5) transparent; /* slate-600 with opacity */
}

.dark .scrollable-nav::-webkit-scrollbar-thumb {
  background-color: rgb(71 85 105 / 0.5); /* slate-600 with opacity */
}

.dark .scrollable-nav::-webkit-scrollbar-thumb:hover {
  background-color: rgb(100 116 139 / 0.7); /* slate-500 with opacity */
}
</style>
